import React from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'react-chartjs-2'

ChartJS.register(ArcElement, Tooltip, Legend)

const MembershipMetricsDoughnut = ({
  data = [],
  labels = [],
  title = '',
  amount = false
}) => {
  const options = {
    responsive: true,
    cutout: '70%',
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 15,
          padding: 15
        }
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || ''
            const currentValue = context.parsed
            const total = context.chart.data.datasets[0].data.reduce(
              (sum, value) => sum + value,
              0
            )
            const percentage = ((currentValue / total) * 100).toFixed(1)
            const valueDisplay = amount ? `$${currentValue}` : currentValue
            return `${label}: ${valueDisplay} (${percentage}%)`
          }
        }
      }
    }
  }

  const centerTextPlugin = {
    id: 'centerText',
    beforeDraw: (chart) => {
      const { ctx, width, height } = chart
      const totalActiveMemberships = chart.data.datasets[0].data.reduce(
        (sum, value) => sum + value,
        0
      )

      ctx.save()
      ctx.font = 'bold 14px sans-serif'
      ctx.textBaseline = 'middle'
      ctx.textAlign = 'center'
      ctx.fillStyle = '#333'

      const totalText = totalActiveMemberships.toString()
      ctx.fillText(`${amount ? '$' : ''}${totalText}`, width / 2, height / 3)
      ctx.font = '14px sans-serif'
      ctx.fillText(title, width / 2, height / 3 + 20)

      ctx.restore()
    }
  }

  return (
    <div className='chart'>
      <Doughnut
        data={{
          labels,
          datasets: [
            {
              data,
              backgroundColor: ['#4CAF50', '#2196F3', '#FFC107'],
              borderColor: ['#fff', '#fff'],
              borderWidth: 2
            }
          ]
        }}
        options={options}
        plugins={[centerTextPlugin]}
      />
    </div>
  )
}

export default MembershipMetricsDoughnut
